import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { useGeneralStore } from "%/stores/general-store";
import { useCourseStore } from "@/stores/course-store";

export const useLessonFeedStore = defineSmartFeedPiniaStore(
  "lesson-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      defaultFilterValues: {
        publicationId: {
          key: "publication_id",
          payload: useCreatorPublicationStore().publicationId,
        },
        orgId: {
          key: "org_id",
          payload: useGeneralStore().orgId,
        },
        courseId: {
          key: "course_id",
          payload: useCourseStore().courseId,
        },
      },
      tableFields: [
        {
          key: "name",
          label: "Name",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "actions",
          label: "",
        },
      ],
    }),
    getters: {
      feedUrl() {
        return `/courses/${useCreatorPublicationStore().publicationId}/${
          useCourseStore().courseId
        }`;
      },
    },
  },
);
